

















































import { Component, Vue, Prop } from "vue-property-decorator";
import { DataTableHeader } from "vuetify/types";

interface TheadProps {
  isMobile: boolean;
  props: {
    headers: DataTableHeader[];
    options: {
      page: number;
      itemsPerPage: number;
      sortBy: string[];
      sortDesc: boolean[];
      groupBy: string[];
      groupDesc: boolean[];
      multiSort: boolean;
      mustSort: boolean;
    };
    mobile: boolean;
    showGroupBy: boolean;
    someItems: boolean;
    everyItem: boolean;
  };
  on: {
    sort: (value: string) => void;
    group: (value: string) => void;
    "toggle-select-all": (value: boolean) => void;
  };
}

@Component
export default class BetterThead extends Vue {
  @Prop({ required: true }) data!: TheadProps;

  headerStyle(h: DataTableHeader) {
    if (h.width) return `min-width: ${h.width}`;
    return "";
  }

  headerCss(h: DataTableHeader, props: { sortBy: string[]; sortDesc: boolean[] }) {
    const css: { [key: string]: boolean } = {};
    if (h.sortable !== false) {
      css.sortable = true;
      const idx = (props.sortBy || []).indexOf(h.value);
      if (idx >= 0) {
        css.active = true;
        if (props.sortDesc[idx]) css.desc = true;
        else css.asc = true;
      }
    }
    return css;
  }

  labelCss(h: DataTableHeader) {
    const css: { [key: string]: boolean } = {
      "d-flex": true,
      "align-center": true,
      label: true
    };
    if (h.align) {
      css[`text-${h.align}`] = true;
      css[`justify-${h.align}`] = true;
    } else {
      css["text-center"] = true;
      css["justify-center"] = true;
    }
    return css;
  }
}
